import React from 'react';
import logo from '../../img/logo.png';
import './logo.css';

const Logo = () => {
    return(
        <figure className="figure-logo">
            <img src={logo} alt="Isela Reyes Perdomo LOGO" className="Logo"/>
        </figure>
    )
}

export default Logo;
